module.exports = __webpack_public_path__ + "img/2.61bb9462.png";